// Hộp thư kín "Tố giác & Góp ý" (QĐ 0272) — hai trang: người gửi và người đọc.
//
// Bài cố ý KHÔNG nói chức danh người nhận thư, KHÔNG nêu mức thưởng, KHÔNG kể
// máy giữ gì và giấu gì: khung thưởng và hai cách gửi đã ghi ngay trên biểu mẫu,
// nhắc lại ở đây chỉ thêm một chỗ phải sửa khi đổi.

import type { GuideBook } from "../types";

export const SEALED_INBOX_GUIDES: GuideBook = {
  sealed_inbox: {
    purpose: "Gửi thư kín để tố giác việc sai, báo vấn đề trong công ty hoặc góp ý thẳng tới người nhận thư.",
    where: [
      'Đầu trang: tên trang "Tố giác & Góp ý" và nút "+ Gửi thư mới".',
      "Khối ngay dưới đầu trang: hai cách gửi (Kín danh, Ẩn danh hoàn toàn) và Khung thưởng — đọc một lượt trước khi gửi thư đầu tiên.",
      'Khối "Thư kín danh của tôi": các thư bạn đã gửi theo cách kín danh, thư nào có trả lời mới thì in đậm kèm chấm đỏ.',
      'Khối "Tra cứu thư ẩn danh": ô "Mã tra cứu" và nút "Mở thư" — dùng để mở lại thư đã gửi ẩn danh.',
      'Trong hộp gửi thư: chọn cách gửi, chọn loại thư, ô "Tiêu đề", ô "Nội dung", nút thêm ảnh và nút "Gửi thư".',
    ],
    howItWorks: [
      "Thư gửi thẳng tới hộp thư kín, không qua quản lý trực tiếp hay bất kỳ ai ở cơ sở.",
      "Kín danh: chỉ người nhận thư biết bạn là ai; thư nằm ở khối Thư kín danh của tôi để bạn theo dõi.",
      "Ẩn danh hoàn toàn: không ai biết bạn là ai; thư không nằm ở Thư kín danh của tôi, chỉ mở lại được bằng mã tra cứu.",
      "Mã tra cứu chỉ hiện MỘT lần ngay sau khi gửi — mất mã là không ai mở lại được thư đó cho bạn.",
      "Người nhận thư có thể hỏi lại; bạn trả lời ngay trong thư. Không có chuông báo — chấm đỏ ở mục menu là dấu có tin mới.",
      "Thư đã gửi không sửa, không xoá được — muốn thêm gì thì viết bổ sung ngay trong thư.",
      "Ảnh bằng chứng tải lên sau khi thư đã lưu; một ảnh hỏng không làm mất thư.",
    ],
    statuses: [
      { label: "Mới", meaning: "Thư đã tới hộp, chưa có người xem xét." },
      { label: "Đang xác minh", meaning: "Người nhận thư đang tìm hiểu, có thể hỏi lại bạn." },
      { label: "Đã kết luận", meaning: "Đã có kết luận; thư khoá lại, không bổ sung được nữa." },
      { label: "Đúng · hữu ích", meaning: "Thông tin đúng và giúp ích cho công ty." },
      { label: "Chưa đủ căn cứ", meaning: "Chưa xác minh được; không ảnh hưởng gì tới bạn." },
      { label: "Cố ý bịa đặt", meaning: "Thông tin được kết luận là dựng chuyện." },
    ],
    blocks: [
      {
        for: ["reception", "sale", "photo", "makeup", "assistant", "retouch", "cskh", "marketing", "accounting", "qc", "lead", "exec"],
        title: "Gửi một thư",
        steps: [
          'Bấm "+ Gửi thư mới".',
          "Chọn cách gửi: Kín danh hoặc Ẩn danh hoàn toàn.",
          "Chọn loại thư: Tố giác một người, Báo vấn đề, hoặc Góp ý.",
          "Tố giác một người thì tìm tên người đó trong danh sách, không có thì gõ tay tên.",
          "Ghi tiêu đề ngắn và kể rõ sự việc: ở đâu, khi nào, ai liên quan.",
          "Có ảnh thì thêm ảnh, rồi bấm \"Gửi thư\".",
          "Gửi ẩn danh thì chép mã tra cứu ra chỗ an toàn, tích \"Tôi đã lưu mã\" rồi mới đóng hộp.",
        ],
        troubles: [
          "Hộp báo lỗi và chưa gửi được: đọc dòng chữ đỏ, sửa đúng chỗ đó rồi bấm Gửi thư lần nữa — thư không bị gửi hai lần.",
          "Quên chép mã tra cứu: không lấy lại được; muốn bổ sung thì gửi một thư mới.",
          "Ảnh không lên: thư vẫn đã gửi; ảnh quá nặng hoặc không phải ảnh chụp thì chọn ảnh khác.",
        ],
      },
      {
        for: ["reception", "sale", "photo", "makeup", "assistant", "retouch", "cskh", "marketing", "accounting", "qc", "lead", "exec"],
        title: "Theo dõi thư đã gửi",
        steps: [
          'Thư kín danh: mở khối "Thư kín danh của tôi", bấm vào thư để xem trả lời.',
          'Thư ẩn danh: gõ mã vào ô "Mã tra cứu", bấm "Mở thư".',
          "Thấy câu hỏi lại thì trả lời ở ô Viết bổ sung ngay trong thư, có thể thêm ảnh.",
          "Thư đã kết luận thì đọc lời nhắn kết luận; thư khoá lại, không gửi thêm được.",
        ],
        troubles: [
          "Mở thư báo không tìm thấy: kiểm lại mã, gõ hoa hay thường và có gạch nối hay không đều được.",
          "Không thấy thư ẩn danh trong Thư kín danh của tôi: đúng như vậy, thư ẩn danh chỉ mở bằng mã.",
        ],
      },
    ],
    askWho: "Thắc mắc về cách gửi thì đọc khối ngay dưới đầu trang; không muốn hỏi ai thì cứ gửi một thư Góp ý.",
  },

  sealed_inbox_reader: {
    purpose: "Đọc, hỏi lại và kết luận các thư tố giác, báo vấn đề và góp ý gửi tới hộp thư kín.",
    where: [
      'Đầu trang: tên trang "Hộp thư kín" và nút "Người đọc" để xem danh sách người đọc hộp thư.',
      'Hai hàng chip lọc: hàng "loại thư" và hàng "trạng thái", mỗi chip có số thư bên cạnh.',
      "Thân trang: danh sách thư, thư có cái mới in đậm và có chấm đỏ.",
      'Mở một thư: bên trái là nội dung, ảnh và khối "Trao đổi với người gửi"; bên phải là khối "1. Kết luận" và khối "2. Thưởng".',
    ],
    howItWorks: [
      "Không có ô tìm theo chữ: nội dung thư được cất kín, chỉ lọc được theo loại và trạng thái.",
      "Thư ẩn danh hiện chữ Ẩn danh và không có người gửi; thư kín danh hiện tên người gửi với người nhận thư chính.",
      "Mở thư lần đầu là thư chuyển sang Đang xác minh; hỏi lại người gửi ngay trong thư.",
      'Lưu kết luận là thư chuyển sang Đã kết luận; kết luận "Đúng · hữu ích" mới mở khối Thưởng.',
      "Mỗi thư thưởng một lần; quyết thưởng rồi thì không sửa kết luận được nữa.",
      "Thưởng vào lương thì chọn tháng lương; trả ngoài thì trả xong phải ghi đã trả.",
    ],
    statuses: [
      { label: "Mới", meaning: "Chưa ai mở thư." },
      { label: "Đang xác minh", meaning: "Đã mở, đang tìm hiểu hoặc chờ người gửi trả lời." },
      { label: "Đã kết luận", meaning: "Đã lưu kết luận; người gửi đọc được lời nhắn kết luận." },
      { label: "Ẩn danh", meaning: "Thư không có người gửi, không có thưởng." },
      { label: "chờ trả", meaning: "Đã quyết thưởng trả ngoài nhưng chưa ghi đã trả." },
    ],
    blocks: [
      {
        for: ["exec"],
        title: "Xử lý một thư",
        steps: [
          "Bấm chip lọc để gom thư theo loại hoặc trạng thái, rồi mở thư cần xem.",
          'Cần thêm thông tin thì gõ vào ô "Hỏi lại người gửi" và bấm "Gửi câu hỏi".',
          "Xác minh xong thì chọn kết luận, ghi lý do, thêm lời nhắn cho người gửi nếu muốn, bấm \"Lưu kết luận\".",
          'Thư kín danh được kết luận "Đúng · hữu ích": chọn mức thưởng, chọn đường trả, chọn tháng lương nếu trả vào lương, bấm Quyết thưởng.',
          'Trả ngoài: trả xong mở lại thư, nhập ngày trả, chọn cách trả, bấm "Ghi đã trả".',
          'Thêm hoặc gỡ người đọc: bấm "Người đọc", chọn người trong danh sách, bấm "Thêm".',
        ],
        troubles: [
          "Bấm lưu mà hiện chữ đỏ: đọc nguyên lời báo, đó là lý do thư chưa lưu được.",
          "Không thấy khối Thưởng: chỉ người nhận thư chính mới quyết thưởng; người đọc thêm chỉ kết luận.",
          "Không thấy nút Sửa kết luận: thư đã quyết thưởng nên kết luận đã khoá.",
          "Không thấy một thư mà người khác thấy: người đọc thêm không đọc được thư tố chính họ.",
        ],
      },
    ],
    askWho: "Thắc mắc về cách dùng hộp thư thì hỏi người nhận thư chính.",
  },
};
